"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDateFunction = exports.dayShort = exports.dayNames = exports.monthShort = exports.monthNames = exports.fdatetime = void 0;
var padNumber_1 = require("./padNumber");
/**
 * formatuje datę i czas do formatu yyyy-MM-dd HH:mm:ss
 * @param dt data typu Date
 */
function fdatetime(dt, format) {
    if (!isNaN(dt.getTime())) {
        return exports.formatDateFunction[format || 'yyyy-MM-dd HH:mm:ss'](dt);
    }
    return '';
    // return fdate(dt) + ' ' + ftime(dt);
}
exports.fdatetime = fdatetime;
exports.monthNames = [
    'styczeń',
    'luty',
    'marzec',
    'kwiecień',
    'maj',
    'czerwiec',
    'lipiec',
    'sierpień',
    'wrzesień',
    'październik',
    'listopad',
    'grudzień'
];
exports.monthShort = [
    'sty',
    'lut',
    'mar',
    'kwi',
    'maj',
    'cze',
    'lip',
    'sie',
    'wrz',
    'paź',
    'lis',
    'gru'
];
exports.dayNames = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];
exports.dayShort = ['Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So', 'N'];
exports.formatDateFunction = {
    'dd.MM.yyyy': function (dt) { return (0, padNumber_1.default)(dt.getDate()) + '.' + (0, padNumber_1.default)(dt.getMonth() + 1) + '.' + dt.getFullYear(); },
    'yyyy-MM-dd': function (dt) { return dt.getFullYear() + '-' + (0, padNumber_1.default)(dt.getMonth() + 1) + '-' + (0, padNumber_1.default)(dt.getDate()); },
    'MMMM yyyy': function (dt) { return exports.monthNames[dt.getMonth()] + " " + dt.getFullYear(); },
    'MMM yyyy': function (dt) { return exports.monthShort[dt.getMonth()] + " " + dt.getFullYear(); },
    dddd: function (dt) { return exports.dayNames[dt.getDay()]; },
    ddd: function (dt) { return exports.dayShort[dt.getDay()]; },
    dd: function (dt) { return (0, padNumber_1.default)(dt.getDate()); },
    d: function (dt) { return dt.getDate().toString(); },
    MMMM: function (dt) { return exports.monthNames[dt.getMonth()]; },
    MMM: function (dt) { return exports.monthShort[dt.getMonth()]; },
    MM: function (dt) { return (0, padNumber_1.default)(dt.getMonth() + 1); },
    M: function (dt) { return (dt.getMonth() + 1).toString(); },
    HH: function (dt) { return (0, padNumber_1.default)(dt.getHours()); },
    H: function (dt) { return dt.getHours().toString(); },
    mm: function (dt) { return (0, padNumber_1.default)(dt.getMinutes()); },
    m: function (dt) { return dt.getMinutes().toString(); },
    ss: function (dt) { return (0, padNumber_1.default)(dt.getSeconds()); },
    s: function (dt) { return dt.getSeconds().toString(); },
    'HH:mm:ss': function (dt) {
        return (0, padNumber_1.default)(dt.getHours()) + ":" + (0, padNumber_1.default)(dt.getMinutes()) + ":" + (0, padNumber_1.default)(dt.getSeconds());
    },
    'dd.MM.yyyy HH:mm:ss': function (dt) {
        return exports.formatDateFunction['dd.MM.yyyy'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt);
    },
    'yyyy-MM-dd HH:mm:ss': function (dt) {
        return exports.formatDateFunction['yyyy-MM-dd'](dt) + ' ' + exports.formatDateFunction['HH:mm:ss'](dt);
    }
};
exports.default = fdatetime;
//# sourceMappingURL=fdatetime.js.map